import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import Notiflix from "notiflix";

import {
    Input,
    Row,
    Typography,
    Card,
    Select,
    Table,
    Form,
    DatePicker,
    Col,
    Divider,
    Button,
    Modal,
    Spin,
    Tooltip,
    Statistic
} from "antd";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from '../../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../../group.config";
import CustomButton from '../../../../../../components/custom/CustomButton';
import styles from '../../../../../../assets/styles/styles';

import dayjs from "dayjs";
import TextArea from 'antd/es/input/TextArea';
import appStatic from '../../../../../../config/appStatic';

const { Text, Title } = Typography

const ModifyApplication = (props) => {

    const { monthList } = appStatic;
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [useForm] = Form.useForm();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [glimLoanProdDetails, setGlimLoanProdDetails] = useState([]);
    const [templateProdDetail, setTemplateProdDetail] = useState({});
    const [loanPurposeOptions, setLoanPurposeOptions] = useState([]);
    const [fundOptions, setFundOptions] = useState([]);
    const [termFrequencyTypeOptions, setTermFrequencyTypeOptions] = useState([]);
    const [repaymentFrequencyTypeOptions, setRepaymentFrequencyTypeOptions] = useState([]);
    const [repaymentFrequencyNthDayTypeOptions, setRepaymentFrequencyNthDayTypeOptions] = useState([]);
    const [repaymentFrequencyDaysOfWeekTypeOptions, setRepaymentFrequencyDaysOfWeekTypeOptions] = useState([]);
    const [interestTypeOptions, setInterestTypeOptions] = useState([]);
    const [amortizationTypeOptions, setAmortizationTypeOptions] = useState([]);
    const [interestCalculationPeriodTypeOptions, setInterestCalculationPeriodTypeOptions] = useState([]);
    const [transactionProcessingStrategyOptions, setTransactionProcessingStrategyOptions] = useState([]);
    const [linkAccountOptions, setLinkAccountOptions] = useState([]);
    const [loanOfficerOptions, setLoanOfficerOptions] = useState([]);
    const [loanCollateralOptions, setLoanCollateralOptions] = useState([]);
    const [interestRateType, setInterestRateType] = useState("");
    const [collateralTableSource, setCollateralTableSource] = useState([]);
    const [chargeTableSource, setChargeTableSource] = useState([]);
    const [disbursementTableSource, setDisbursementTableSource] = useState([]);
    const [chargesOptions, setChargesOptions] = useState([]);
    const [templateChargeId, setTemplateChargeId] = useState(0);
    const [productData, setProductData] = useState([]);
    const [chargeList, setChargeList] = useState([]);
    const [collateralList, setCollateralList] = useState([]);
    const [chargeTableCount, setChargeTableCount] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [productId, setProductId] = useState(0);
    const [isRepaidEveryMonth, setIsRepaidEveryMonth] = useState(false);
    const [allowPartialPeriodInterestCalcualtion, setAllowPartialPeriodInterestCalcualtion] = useState(false);
    const [symbol, setSymbol] = useState("");

    useEffect(() => {
        getDetalById();
        getClientsTemplate();
    }, []);


    function getDetalById() {

        const params = {
            associations: "charges,collateral,meeting,multiDisburseDetails",
            staffInSelectedOfficeOnly: true,
            template: true
        }

        const url = `${apiConfig.Loans}/${state.loanId}`

        let body = {
            session,
            params
        };

        setIsLoading(true)

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err);
            } else {
                const objList = res;
                setGlimLoanProdDetails(objList);

                let tempLoanPurposeOptions = [];
                let tempFundOptions = [];
                let tempTermFrequencyTypeOptions = [];
                let tempRepaymentFrequencyTypeOptions = [];
                let tempRepaymentFrequencyNthDayTypeOptions = [];
                let tempRepaymentFrequencyDaysOfWeekTypeOptions = [];
                let tempInterestTypeOptions = [];
                let tempAmortizationTypeOptions = [];
                let tempInterestCalculationPeriodTypeOptions = [];
                let tempTransactionProcessingStrategyOptions = [];
                let tempCharges = [];
                let tempChargesOptions = [];
                let tempLoanCollateralOptions = [];
                let tempdisbursementData = [];
                let tempProducts = [];
                let tempLinkAccountOptions = [];
                let tempLoanOfficerOptions = [];
                setProductId(objList?.product?.id);
                setInterestRateType(objList?.interestRateFrequencyType?.value);
                setAllowPartialPeriodInterestCalcualtion(objList?.allowPartialPeriodInterestCalcualtion)
                setSymbol(objList?.product?.currency?.displaySymbol)
                getLoanTemplate(objList?.product?.id);

                useForm.setFieldsValue({
                    productId: objList?.loanProductId,
                    graceOnPrincipalPayment: objList?.graceOnPrincipalPayment,
                    graceOnInterestPayment: objList?.graceOnInterestPayment,
                    graceOnArrearsAgeing: objList?.graceOnArrearsAgeing,
                    loanOfficerId: objList?.loanOfficerId,
                    loanTermFrequencyType: objList?.termPeriodFrequencyType?.id,
                    loanTermFrequency: objList?.termFrequency,
                    submittedOnDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.timeline?.submittedOnDate)),
                    expectedDisbursementDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.timeline?.expectedDisbursementDate)),
                    repaymentEvery: objList?.repaymentEvery,
                    repaymentFrequencyType: objList?.repaymentFrequencyType?.id,
                    numberOfRepayments: objList?.numberOfRepayments,
                    amortizationType: objList?.amortizationType?.id,
                    principal: objList?.approvedPrincipal,
                    interestRatePerPeriod: objList?.interestRatePerPeriod,
                    isEqualAmortization: objList?.isEqualAmortization,
                    inArrearsTolerance: objList?.inArrearsTolerance,
                    transactionProcessingStrategyId: objList?.transactionProcessingStrategyId,
                    interestType: objList?.interestType?.id,
                    recalculateInterest: objList?.isInterestRecalculationEnabled ? "Yes" : "No",
                    daysInYear: objList?.daysInYearType?.value,
                    startDate: objList?.calendarOptions[0]?.startDate
                        ? BOM.FormatArrayDateWithoutYear(objList?.calendarOptions[0]?.startDate)
                        : " - ",
                    repeatsOn: objList?.calendarOptions[0]?.humanReadable
                        ? objList?.calendarOptions[0]?.humanReadable
                        : " - ",
                    syncDisbursementWithMeeting: objList?.syncDisbursementWithMeeting,
                    createStandingInstructionAtDisbursement: objList?.createStandingInstructionAtDisbursement,
                    repaymentFrequencyDayOfWeekType: objList?.repaymentFrequencyDayOfWeekType?.id,
                    interestCalculationPeriodType: objList?.interestCalculationPeriodType?.id,
                });

                objList?.fundOptions?.forEach((element) => {
                    tempFundOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.loanPurposeOptions?.forEach((element) => {
                    tempLoanPurposeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.accountLinkingOptions?.forEach((element) => {
                    tempLinkAccountOptions.push({
                        value: element.id,
                        label: element.productName,
                    });
                });

                objList?.termFrequencyTypeOptions?.forEach((element) => {
                    tempTermFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyNthDayTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyDaysOfWeekTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestTypeOptions?.forEach((element) => {
                    tempInterestTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.amortizationTypeOptions?.forEach((element) => {
                    tempAmortizationTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
                    tempInterestCalculationPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.transactionProcessingStrategyOptions?.forEach((element) => {
                    tempTransactionProcessingStrategyOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.disbursementDetails?.forEach((element) => {
                    tempdisbursementData.push({
                        key: element?.id,
                        id: element?.id,
                        expectedDisbursementDate: element?.expectedDisbursementDate ? (`${element?.expectedDisbursementDate[2]} ${monthList[element?.expectedDisbursementDate[1] - 1]} ${element?.expectedDisbursementDate[0]}`) : "-",
                        principal: element?.principal ? element?.principal : "-",
                    });
                });

                const chargesLength = objList?.charges?.length || 0;
                setChargeTableCount(chargesLength);

                objList?.charges?.forEach((element, index) => {
                    tempCharges.push({
                        key: index + 1,
                        id: element?.id ? element?.id : "-",
                        chargeId: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        amountToUse: element.amount ? element.amount : 0,
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        dueDate: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",
                    });
                });

                objList?.chargeOptions?.forEach((element) => {
                    tempChargesOptions.push({
                        value: element.id,
                        label: `${element.name}(${element?.currency?.name})`,
                    });
                });

                objList?.loanCollateralOptions?.forEach((element) => {
                    tempLoanCollateralOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.productOptions?.forEach((element) => {
                    tempProducts.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.loanOfficerOptions?.forEach((element) => {
                    tempLoanOfficerOptions.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                if (objList?.repaymentFrequencyType?.value.toLowerCase() === "months") {
                    setIsRepaidEveryMonth(true);
                } else {
                    setIsRepaidEveryMonth(false);
                };

                setProductData(tempProducts);
                setLoanOfficerOptions(tempLoanOfficerOptions);
                setChargesOptions(tempChargesOptions);
                setLinkAccountOptions(tempLinkAccountOptions);
                setFundOptions(tempFundOptions);
                setLoanPurposeOptions(tempLoanPurposeOptions);
                setTermFrequencyTypeOptions(tempTermFrequencyTypeOptions);
                setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
                setRepaymentFrequencyNthDayTypeOptions(tempRepaymentFrequencyNthDayTypeOptions);
                setRepaymentFrequencyDaysOfWeekTypeOptions(tempRepaymentFrequencyDaysOfWeekTypeOptions);
                setInterestTypeOptions(tempInterestTypeOptions);
                setAmortizationTypeOptions(tempAmortizationTypeOptions);
                setInterestCalculationPeriodTypeOptions(tempInterestCalculationPeriodTypeOptions);
                setTransactionProcessingStrategyOptions(tempTransactionProcessingStrategyOptions)
                setTemplateChargeId(objList?.charges[0]?.id);
                setLoanCollateralOptions(tempLoanCollateralOptions)
                setDisbursementTableSource(tempdisbursementData)
                setChargeTableSource(tempCharges);
                setIsLoading(false);
            };
        });
    };
    function getLoanTemplate(productId) {

        const params = {
            fields: "id,loanCollateralOptions",
            productId,
            templateType: "collateral"
        }

        const url = `${apiConfig.Loans}/template`

        let body = {
            session,
            params
        };

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err);
            } else {
                const objList = res;
            };
        });
    };
    function getClientsTemplate() {

        const url = `${apiConfig.Clients}/${state.clientId}/collaterals/template`
        let body = {
            session,
        };

        setIsLoading(true)
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err);
            } else {
                setIsLoading(false)
                const objList = res;
            }
        });
    };
    const onChangeProduct = (productParam) => {
        setProductId(productParam);
        const params = {
            clientId: state.clientId,
            groupId: state.groupId,
            productId: productParam,
            staffInSelectedOfficeOnly: true,
            templateType: "jlg"
        };
        const url = `${apiConfig.Loans}/template`;

        let body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            } else {
                const objList = res;
                setSymbol(objList?.product?.currency?.displaySymbol);
                setAllowPartialPeriodInterestCalcualtion(objList?.allowPartialPeriodInterestCalcualtion);
                setInterestRateType(objList?.interestRateFrequencyType?.value)
                setGlimLoanProdDetails(objList);

                let tempLoanPurposeOptions = [];
                let tempFundOptions = [];
                let tempTermFrequencyTypeOptions = [];
                let tempRepaymentFrequencyTypeOptions = [];
                let tempRepaymentFrequencyNthDayTypeOptions = [];
                let tempRepaymentFrequencyDaysOfWeekTypeOptions = [];
                let tempInterestTypeOptions = [];
                let tempAmortizationTypeOptions = [];
                let tempInterestCalculationPeriodTypeOptions = [];
                let tempTransactionProcessingStrategyOptions = [];
                let tempCharges = [];
                let tempChargesOptions = [];
                let tempLoanCollateralOptions = [];
                let tempdisbursementData = [];
                let tempProducts = [];
                let tempLinkAccountOptions = [];
                let tempLoanOfficerOptions = [];
                setProductId(objList?.product?.id);
                getLoanTemplate(productParam);

                useForm.setFieldsValue({
                    productId: objList?.loanProductId,
                    graceOnPrincipalPayment: objList?.graceOnPrincipalPayment,
                    graceOnInterestPayment: objList?.graceOnInterestPayment,
                    graceOnArrearsAgeing: objList?.graceOnArrearsAgeing,
                    loanOfficerId: objList?.loanOfficerId,
                    loanTermFrequencyType: objList?.termPeriodFrequencyType?.id,
                    loanTermFrequency: objList?.termFrequency,
                    submittedOnDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.timeline?.submittedOnDate)),
                    expectedDisbursementDate: dayjs(BOM.FormatArrayDateWithoutYear(objList?.timeline?.expectedDisbursementDate)),
                    repaymentEvery: objList?.repaymentEvery,
                    repaymentFrequencyType: objList?.repaymentFrequencyType?.id,
                    numberOfRepayments: objList?.numberOfRepayments,
                    amortizationType: objList?.amortizationType?.id,
                    principal: objList?.approvedPrincipal,
                    interestRatePerPeriod: objList?.interestRatePerPeriod,
                    isEqualAmortization: objList?.isEqualAmortization,
                    inArrearsTolerance: objList?.inArrearsTolerance,
                    transactionProcessingStrategyId: objList?.transactionProcessingStrategyId,
                    interestType: objList?.interestType?.id,
                    recalculateInterest: objList?.isInterestRecalculationEnabled ? "Yes" : "No",
                    daysInYear: objList?.daysInYearType?.value,
                    startDate: objList?.calendarOptions[0]?.startDate
                        ? BOM.FormatArrayDateWithoutYear(objList?.calendarOptions[0]?.startDate)
                        : " - ",
                    repeatsOn: objList?.calendarOptions[0]?.humanReadable
                        ? objList?.calendarOptions[0]?.humanReadable
                        : " - ",
                    syncDisbursementWithMeeting: objList?.syncDisbursementWithMeeting,
                    createStandingInstructionAtDisbursement: objList?.createStandingInstructionAtDisbursement,
                    repaymentFrequencyDayOfWeekType: objList?.repaymentFrequencyDayOfWeekType?.id,
                    interestCalculationPeriodType: objList?.interestCalculationPeriodType?.id,
                });

                objList?.fundOptions?.forEach((element) => {
                    tempFundOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.loanPurposeOptions?.forEach((element) => {
                    tempLoanPurposeOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.accountLinkingOptions?.forEach((element) => {
                    tempLinkAccountOptions.push({
                        value: element.id,
                        label: element.productName,
                    });
                });

                objList?.termFrequencyTypeOptions?.forEach((element) => {
                    tempTermFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyNthDayTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyNthDayTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.repaymentFrequencyDaysOfWeekTypeOptions?.forEach((element) => {
                    tempRepaymentFrequencyDaysOfWeekTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestTypeOptions?.forEach((element) => {
                    tempInterestTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.amortizationTypeOptions?.forEach((element) => {
                    tempAmortizationTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.interestCalculationPeriodTypeOptions?.forEach((element) => {
                    tempInterestCalculationPeriodTypeOptions.push({
                        value: element.id,
                        label: element.value,
                    });
                });

                objList?.transactionProcessingStrategyOptions?.forEach((element) => {
                    tempTransactionProcessingStrategyOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.disbursementDetails?.forEach((element) => {
                    tempdisbursementData.push({
                        key: element?.id,
                        id: element?.id,
                        expectedDisbursementDate: element?.expectedDisbursementDate ? (`${element?.expectedDisbursementDate[2]} ${monthList[element?.expectedDisbursementDate[1] - 1]} ${element?.expectedDisbursementDate[0]}`) : "-",
                        principal: element?.principal ? element?.principal : "-",
                    });
                });

                const chargesLength = objList?.charges?.length || 0;
                setChargeTableCount(chargesLength);

                objList?.charges?.forEach((element, index) => {
                    tempCharges.push({
                        key: index + 1,
                        id: element?.id ? element?.id : "-",
                        chargeId: element?.chargeId ? element?.chargeId : "-",
                        name: element?.name ? element?.name : "-",
                        type: element?.chargeCalculationType?.value
                            ? element?.chargeCalculationType?.value
                            : "-",
                        amount: element?.amount ? (
                            <Statistic
                                value={element?.amount}
                                precision={2}
                                valueStyle={{ fontSize: "16px" }}
                            />
                        ) : (
                            0
                        ),
                        amountToUse: element.amount ? element.amount : 0,
                        collectedOn: element?.chargeTimeType?.value
                            ? element?.chargeTimeType?.value
                            : "-",
                        dueDate: element?.feeOnMonthDay
                            ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
                            : "-",
                    });
                });

                objList?.chargeOptions?.forEach((element) => {
                    tempChargesOptions.push({
                        value: element.id,
                        label: `${element.name}(${element?.currency?.name})`,
                    });
                });

                objList?.loanCollateralOptions?.forEach((element) => {
                    tempLoanCollateralOptions.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.productOptions?.forEach((element) => {
                    tempProducts.push({
                        value: element.id,
                        label: element.name,
                    });
                });

                objList?.loanOfficerOptions?.forEach((element) => {
                    tempLoanOfficerOptions.push({
                        value: element.id,
                        label: element.displayName,
                    });
                });

                if (objList?.repaymentFrequencyType?.value.toLowerCase() === "months") {
                    setIsRepaidEveryMonth(true);
                } else {
                    setIsRepaidEveryMonth(false);
                };

                setProductData(tempProducts);
                setLoanOfficerOptions(tempLoanOfficerOptions);
                setChargesOptions(tempChargesOptions);
                setLinkAccountOptions(tempLinkAccountOptions);
                setFundOptions(tempFundOptions);
                setLoanPurposeOptions(tempLoanPurposeOptions);
                setTermFrequencyTypeOptions(tempTermFrequencyTypeOptions);
                setRepaymentFrequencyTypeOptions(tempRepaymentFrequencyTypeOptions);
                setRepaymentFrequencyNthDayTypeOptions(tempRepaymentFrequencyNthDayTypeOptions);
                setRepaymentFrequencyDaysOfWeekTypeOptions(tempRepaymentFrequencyDaysOfWeekTypeOptions);
                setInterestTypeOptions(tempInterestTypeOptions);
                setAmortizationTypeOptions(tempAmortizationTypeOptions);
                setInterestCalculationPeriodTypeOptions(tempInterestCalculationPeriodTypeOptions);
                setTransactionProcessingStrategyOptions(tempTransactionProcessingStrategyOptions)
                setTemplateChargeId(objList?.charges[0]?.id);
                setLoanCollateralOptions(tempLoanCollateralOptions)
                setDisbursementTableSource(tempdisbursementData)
                setChargeTableSource(tempCharges);
                setIsLoading(false);
            };
        });
        setIsLoading(false);
    };
    const handleLoanType = (valueParam) => {
        return templateProdDetail.hasOwnProperty("clientId") &&
            templateProdDetail.hasOwnProperty("group")
            ? (valueParam.loanType = "jlg")
            : templateProdDetail.hasOwnProperty("clientId")
                ? (valueParam.loanType = "individual")
                : templateProdDetail.hasOwnProperty("group")
                    ? (valueParam.loanType = "group")
                    : null;
    };
    function onCancel() {
        navigate("/detail-child-glim", { state: state });
    };
    const handleChargeDelete = (key) => {
        let action = "Delete  ";
        let label = BOM.SubstringFormat(key.name, 20);

        Notiflix.Confirm.show(
            "Are you sure?",
            action + label,
            "Yes",
            "No",

            function () {
                const newData = chargeTableSource.filter((item) => item.id !== key.id);
                setChargeTableSource(newData);
            },

            function () {
                // No button
            }
        );
    };
    const handleCollateralDelete = (key) => {
        let action = "Delete  ";
        let label = BOM.SubstringFormat(key.type, 20);

        Notiflix.Confirm.show(
            "Are you sure?",
            action + label,
            "Yes",
            "No",

            function () {
                const newData = collateralTableSource.filter(
                    (item) => item.id !== key.id
                );
                setCollateralTableSource(newData);
            },

            function () {
                // No button
            }
        );
    };

    const columns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Collected On",
            dataIndex: "collectedOn",
        },
        {
            title: "Date",
            dataIndex: "dueDate",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                chargeTableSource.length >= 1 ? (
                    <Tooltip title={`Remove Charge`}>
                        <Button
                            type="primary"
                            icon={<DeleteOutlined />}
                            onClick={() => handleChargeDelete(record)}
                            shape="round"
                            size="small"
                            className="of-primaryBtnColor"
                        />
                    </Tooltip>
                ) : null,
        },
    ];

    const defaultCollateralColumns = [
        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Value",
            dataIndex: "value",
        },
        {
            title: "Description",
            dataIndex: "description",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                collateralTableSource.length >= 1 ? (
                    <Tooltip title={`Remove Collateral`}>
                        <Button
                            type="primary"
                            icon={<DeleteOutlined />}
                            onClick={() => handleCollateralDelete(record)}
                            shape="round"
                            size="small"
                            className="of-primaryBtnColor"
                        />
                    </Tooltip>
                ) : null,
        },
    ];

    const repaymentInfoColumns = [
        {
            title: "Date",
            dataIndex: "date",
        },
        {
            title: "Days",
            dataIndex: "days",
        },
        {
            title: "Disbursement",
            dataIndex: "disbursement",
        },
        {
            title: "Principal Due",
            dataIndex: "principalDue",
        },

        {
            title: "Principal Balance",
            dataIndex: "pricipalBalance",
        },

        {
            title: "Interest Due",
            dataIndex: "interestDue",
        },

        {
            title: "Fees",
            dataIndex: "fees",
        },

        {
            title: "Penalty",
            dataIndex: "penalty",
        },

        {
            title: "Dues",
            dataIndex: "dues",
        },
    ];

    const onSubmit = (formValues) => {

        let tempChargeArray = [];
        chargeTableSource.forEach((element, index) => {
            if (element.dueDate === "-") {
                tempChargeArray.push({
                    id: element.id,
                    chargeId: element.chargeId,
                    amount: element.amountToUse,
                });
            } else {
                tempChargeArray.push({
                    chargeId: element.chargeId,
                    amount: element.amountToUse,
                    dueDate: BOM.DateTime(
                        element.dueDate,
                        "only-date"
                    ),
                });
            }
        });

        formValues.submittedOnDate = BOM.DateTime(formValues.submittedOnDate, "only-date")
        formValues.expectedDisbursementDate = BOM.DateTime(formValues.expectedDisbursementDate, "only-date")
        formValues.interestChargedFromDate = BOM.DateTime(formValues.interestChargedFromDate, "only-date")
        formValues.repaymentsStartingFromDate = formValues.repaymentsStartingFromDate
            ? BOM.DateTime(formValues.repaymentsStartingFromDate, "only-date")
            : undefined;
        formValues.allowPartialPeriodInterestCalcualtion = allowPartialPeriodInterestCalcualtion;
        formValues.clientId = state.clientId;
        formValues.loanType = "jlg";
        formValues.groupId = state.groupId;
        formValues.isTopup = false;
        formValues.disbursementData = [];
        formValues.loanIdToClose = 0;
        formValues.charges = tempChargeArray;
        formValues?.charges.forEach(element =>
            element.id = null
        )

        delete formValues.interestChargedFromDate;
        delete formValues.startDate;
        delete formValues.repeatsOn;
        delete formValues.interestType;
        delete formValues.recalculateInterest;
        delete formValues.daysInYear;

        handleLoanType(formValues);

        const url = `${apiConfig.Loans}/${state.loanId}`

        const body = {
            ...formValues,
            locale: "en",
            method: "PUT",
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            session
        };

        // return
        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.modifyApplicationMsg);
                navigate("/detail-child-glim", { state: state });
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };


    return (

        <MainLayout isEnableRightSidebar={true} >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.modifyLoanApplication}
                pageItems={staticConfig.modifyApplicationBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                    title={
                        <Row
                            style={{
                                alignContent: "center",
                                width: "8%",
                            }}
                        >
                            <Button
                                icon={<LeftOutlined />}
                                type="text"
                                style={{
                                    marginTop: "auto",
                                    marginBottom: "auto",
                                }}
                                onClick={onCancel}
                            >
                                <Text
                                    style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                                >
                                    Back
                                </Text>
                            </Button>
                        </Row>
                    }
                >
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={onSubmit}
                        name='modify-application'
                    >

                        <Row>
                            {/* DETAILS  */}
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>

                            <Divider orientation="left" orientationMargin="0">{"Details"}</Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.product}
                                    name="productId"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.product
                                            ),
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.product,
                                            "select"
                                        )}
                                        options={productData}
                                        onChange={onChangeProduct}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.loanOfficer}
                                    name="loanOfficerId"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.loanOfficer,
                                            "select"
                                        )}
                                        options={loanOfficerOptions}
                                        showSearch
                                        allowClear
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.loanPurpose}
                                    name="loanPurposeId"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.loanPurpose}`,
                                            "select"
                                        )}
                                        options={loanPurposeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.fund}
                                    name="fundId"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.fund}`,
                                            "select"
                                        )}
                                        options={fundOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.submittedOn}
                                    name="submittedOnDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.submittedOn
                                            ),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.submittedOn}`,
                                            "select"
                                        )}
                                        style={{
                                            width: '100%',
                                            height: 35
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.disbursementOn}
                                    name="expectedDisbursementDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(
                                                labelConfig.disbursementOn
                                            ),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.disbursementOn}`,
                                            "select"
                                        )}
                                        style={{
                                            width: '100%',
                                            height: 35
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.externalID}
                                    name="externalID"
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.externalID)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <div></div>
                            </Col>

                            <Divider orientation="left" orientationMargin="0">{"Meeting Details"}</Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.startDate}
                                    name="startDate"
                                >
                                    <Input
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.repeatsOn}
                                    name="repeatsOn"
                                >
                                    <Input
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.syncRepayments}
                                    name="syncRepayments"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.syncRepayments}`,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNo}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.syncDisbursement}
                                    name="syncDisbursementWithMeeting"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.syncDisbursement}`,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNo}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            {/* CASA LINKAGE  */}
                            <Divider orientation="left" orientationMargin="0">{"CASA Linkage"}</Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.linkSavings}
                                    name="linkAccountId"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.linkSavings}`,
                                            "select"
                                        )}
                                        showSearch
                                        options={linkAccountOptions}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.createStandingInstruction}
                                    name="createStandingInstructionAtDisbursement"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.option}`,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNo}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>


                            <Divider orientation="left" orientationMargin="0">{"Terms"}</Divider>

                            {/* TERMS  */}

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={`${labelConfig.principal} (${templateProdDetail?.currency?.displaySymbol
                                        ? templateProdDetail?.currency?.displaySymbol
                                        : "$"
                                        })`}
                                    name="principal"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.principal),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.principal)}
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.loanTerm}
                                    name="loanTermFrequency"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.loanTerm),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.loanTerm)}
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>

                                <Form.Item
                                    label={<Text >{labelConfig.loanTermFrequency}</Text>}
                                    name="loanTermFrequencyType"

                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.loanTerm}`,
                                            "select"
                                        )}
                                        options={termFrequencyTypeOptions}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.repaidEvery}
                                    name="repaymentEvery"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.repaidEvery),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.repaidEvery)}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.repaymentEvery
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>

                                <Form.Item
                                    label={<Text >{labelConfig.repaymentFrequency}</Text>}
                                    name="repaymentFrequencyType"

                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.option}`,
                                            "select"
                                        )}
                                        options={repaymentFrequencyTypeOptions}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.repaymentEvery
                                        }
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                            {isRepaidEveryMonth &&
                                <>
                                    <Col span={8} style={{ padding: "0px 8px" }}>

                                        <Form.Item
                                            label={<Text>{labelConfig.on}</Text>}
                                            name="repaymentFrequencyNthDayType"
                                        >
                                            <Select
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    `${labelConfig.option}`,
                                                    "select"
                                                )}
                                                options={repaymentFrequencyNthDayTypeOptions}
                                                showSearch
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col span={8} style={{ padding: "0px 8px" }}>

                                        <Form.Item
                                            label={<Text>{labelConfig.dayOfWeek}</Text>}
                                            name="repaymentFrequencyDayOfWeekType"
                                        >
                                            <Select
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    `${labelConfig.option}`,
                                                    "select"
                                                )}
                                                options={repaymentFrequencyDaysOfWeekTypeOptions}
                                                showSearch
                                            />
                                        </Form.Item>
                                    </Col>
                                </>
                            }

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.numberOfRepayments}
                                    name="numberOfRepayments"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.numberOfRepayments),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.numberOfRepayments)}

                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.firstRepaymentOn}
                                    name="repaymentsStartingFromDate"
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.firstRepaymentOn}`,
                                            "select"
                                        )}
                                        style={{
                                            width: '100%',
                                            height: 35
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestChargedFrom}
                                    name="interestChargedFromDate"
                                >
                                    <DatePicker
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.interestChargedFrom}`,
                                            "select"
                                        )}
                                        style={{
                                            width: '100%',
                                            height: 35
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={`${labelConfig.nominalInterestRate}  ${interestRateType}`}
                                    name="interestRatePerPeriod"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.nominalInterestRate),
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.nominalInterestRate)}

                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestMethod}
                                    name="interestType"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.interestMethod}`,
                                            "select"
                                        )}
                                        options={interestTypeOptions}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.interestType
                                        }
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.isEqualAmortization}
                                    name="isEqualAmortization"
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.option}`,
                                            "select"
                                        )}
                                        options={[
                                            { label: "Yes", value: true },
                                            { label: "No", value: false }
                                        ]}
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={`${labelConfig.arrearsTolerance} in ${symbol}`}
                                    name="inArrearsTolerance"
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.arrearsTolerance)}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.inArrearsTolerance
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestFreePeriod}
                                    name="graceOnInterestCharged"
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.interestFreePeriod)}

                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.repaymentStrategy}
                                    name="transactionProcessingStrategyId"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.repaymentStrategy),
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.repaymentStrategy}`,
                                            "select"
                                        )}
                                        options={transactionProcessingStrategyOptions}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.transactionProcessingStrategyId
                                        }
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>

                            <Divider orientation="left" orientationMargin="0">{labelConfig.moratorium}</Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.onPrincipalPayment}
                                    name="graceOnPrincipalPayment"
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.onPrincipalPayment)}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.graceOnPrincipalAndInterestPayment
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={8} style={{ padding: "0px 8px" }}>

                                <Form.Item
                                    label={<Text>{labelConfig.onInterestPayment}</Text>}
                                    name="graceOnInterestPayment"

                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.onInterestPayment)}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.graceOnPrincipalAndInterestPayment
                                        }
                                    />

                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>

                                <Form.Item
                                    label={<Text>{labelConfig.onArrearsAging}</Text>}
                                    name="graceOnArrearsAgeing"
                                >
                                    <Input
                                        placeholder={BOM.handlePlaceholderMsg(labelConfig.onArrearsAging)}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.graceOnArrearsAgeing
                                        }
                                    />
                                </Form.Item>
                            </Col>

                            <Divider orientation="left" orientationMargin="0">{labelConfig.interestInformation}</Divider>

                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.recalculateInterest}
                                    name="recalculateInterest"
                                >
                                    <Input
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.daysInYear}
                                    name="daysInYear"
                                >
                                    <Input
                                        disabled
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.amortization}
                                    name="amortizationType"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.amortization),
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.amortization}`,
                                            "select"
                                        )}
                                        options={amortizationTypeOptions}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.amortizationType
                                        }
                                        showSearch
                                        className="of-bold-disable-input"
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.interestCalculationPeriod}
                                    name="interestCalculationPeriodType"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.interestCalculationPeriod),
                                        },
                                    ]}
                                >
                                    <Select
                                        placeholder={BOM.handlePlaceholderMsg(
                                            `${labelConfig.interestCalculationPeriod}`,
                                            "select"
                                        )}
                                        options={interestCalculationPeriodTypeOptions}
                                        disabled={
                                            !glimLoanProdDetails?.product?.allowAttributeOverrides
                                                ?.interestCalculationPeriodType
                                        }
                                        showSearch
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.chargeInfo}
                            </Title>
                        </Divider>
                        <ChargeModal
                            isModalOpen={isModalOpen}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            addLoanTrancheaddLoanTranche
                            chargeData={chargesOptions}
                            setChargeList={setChargeList}
                            setChargeTableSource={setChargeTableSource}
                            chargeTableSource={chargeTableSource}
                            chargeList={chargeList}
                            session={session}
                            setIsModalOpen={setIsModalOpen}
                        />

                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {chargeTableSource.length > 1
                                    ? labelConfig.selectedCharges
                                    : labelConfig.selectedCharge}
                            </Title>
                        </Divider>

                        {chargeTableSource?.length > 0 && (
                            <Table
                                columns={columns}
                                dataSource={chargeTableSource}
                                bordered
                                pagination={{
                                    position: "bottomCentre",
                                    pageSize: "10",
                                }}
                            />
                        )}


                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.collateralInfo}
                            </Title>
                        </Divider>
                        <CollateralModal
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            collateralData={loanCollateralOptions}
                            setCollateralList={setCollateralList}
                            collateralTableSource={collateralTableSource}
                            setCollateralTableSource={setCollateralTableSource}
                            collateralList={collateralList}
                            session={session}
                        />

                        {collateralTableSource?.length > 0 && (
                            <>
                                <Divider orientation="left" orientationMargin="0">
                                    <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                        {collateralTableSource.length > 1
                                            ? labelConfig.selectedCollaterals
                                            : labelConfig.selectedCollateral}
                                    </Title>
                                </Divider>
                                <Table
                                    columns={defaultCollateralColumns}
                                    dataSource={collateralTableSource}
                                    bordered
                                    pagination={{
                                        position: "bottomCentre",
                                        pageSize: "10",
                                    }}
                                />
                            </>
                        )}
                        <Divider orientation="left" orientationMargin="0">
                            <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
                                {labelConfig.repaymentInformation}
                            </Title>
                        </Divider>

                        <RepaymentInfoModal
                            repaymentInfoColumns={repaymentInfoColumns}
                            setIsLoading={setIsLoading}
                            session={session}
                        />

                        <Row>
                            <Divider />
                            {BOM.HasPermission("UPDATE_LOAN") &&
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#92428B"
                                    colorText="white"
                                    hoverBackground="#AD4EA7"
                                />}

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>

                </Card>
            </Spin>

        </MainLayout>
    )
}

export default ModifyApplication

const ChargeModal = (props) => {
    const {
        session,
        isLoading,
        setIsLoading,
        setChargeTableSource,
        chargeTableSource,
        isModalOpen,
        chargeData,
        setIsModalOpen,
    } = props;

    const [useForm] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleChargeSave = (formValues) => {

        const newCharges = {
            key: formValues?.chargeId,
            id: formValues?.chargeId,
            chargeId: formValues?.chargeId,
            name: formValues.name,
            type: formValues.type,
            collectedOn: formValues.collectedOn,
            amountToUse: formValues?.amount,
            amount: (
                <Statistic
                    value={formValues?.amount}
                    precision={2}
                    valueStyle={{ fontSize: "16px" }}
                />
            ),
            dueDate: formValues.dueDate
                ? BOM.DateTime(formValues.dueDate, "only-date")
                : "-",
        };

        let foundCharge = chargeTableSource.find(
            (item) => item.chargeId === newCharges?.chargeId
        );
        if (foundCharge) {
            BOM.AlertMsg(cnt.WARNING, "No duplicate Charge allowed!");
            return;
        }
        setChargeTableSource([...chargeTableSource, newCharges]);

        useForm.resetFields();
    };

    const handleSelectedCharge = (chargeId) => {
        const params = {
            template: "true",
        };

        const url = `${apiConfig.Charges}/${chargeId}`;

        const body = {
            session,
            params,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
            } else {
                const objList = res;

                useForm.setFieldsValue({
                    key: objList.id,
                    id: objList.id,
                    name: objList.name,
                    type: objList.chargeCalculationType.value,
                    collectedOn: objList?.chargeTimeType.value,
                    amount: objList?.amount,
                    dueDate: objList?.feeOnMonthDay
                        ? dayjs(BOM.FormatArrayDate(objList?.feeOnMonthDay))
                        : objList?.feeOnMonthDay,
                });

                // STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <Row>
            <Button
                type="primary"
                onClick={showModal}
                shape="round"
                icon={<PlusOutlined />}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#92428B",
                    marginBottom: 20,
                }}
            >
                {labelConfig.addCharge}
            </Button>

            <Modal
                title="Charge Information Setup"
                open={isModalOpen}
                okText="Add"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={handleChargeSave}
                        name="address-info"
                    >
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Row>
                        <Divider />

                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name={"chargeId"}
                                label={"Charge Options"}
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.charge),
                                    },
                                ]}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.charge,
                                        "select"
                                    )}
                                    options={chargeData}
                                    onChange={handleSelectedCharge}
                                    style={{ width: "30vh" }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Divider />
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.name} name={"name"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.name)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.type} name={"type"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.type)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.collectedOn} name={"collectedOn"}>
                                <Input
                                    disabled
                                    className="of-bold-disable-input"
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.collectedOn
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.amount} name={"amount"}>
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.date} name="dueDate">
                                <DatePicker
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.date,
                                        "select"
                                    )}
                                    style={{ width: "100%", height: 35 }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* </Form> */}
                </Spin>
            </Modal>
        </Row>
    );
};

const CollateralModal = (props) => {
    const {
        isLoading,
        setCollateralTableSource,
        collateralTableSource,
        collateralData,
    } = props;

    const [useForm] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const handleCollateralSave = (formValues) => {
        const newCollateral = {
            key: formValues?.collateralId,
            id: formValues?.collateralId,
            type: collateralData.find(
                (item) => item.value === formValues?.collateralId
            ).label,

            value: formValues.collateralValue,
            description: formValues.description,
        };

        let foundCollateral = collateralTableSource.find(
            (item) => item.id === newCollateral?.id
        );
        if (foundCollateral) {
            BOM.AlertMsg(cnt.WARNING, "No duplicate Collateral allowed!");
            return;
        }
        setCollateralTableSource([...collateralTableSource, newCollateral]);

        useForm.resetFields();
    };

    return (
        <Row>
            <Button
                shape="round"
                type="primary"
                onClick={showModal}
                disabled
                icon={<PlusOutlined />}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#92428B",
                    marginBottom: 20,
                }}
            >
                {labelConfig.addLoanCollateral}
            </Button>

            <Modal
                title="Collateral Information Setup"
                open={isModalOpen}
                okText="Add"
                cancelText="Cancel"
                okButtonProps={{
                    autoFocus: true,
                    htmlType: "submit",
                    style: {
                        ...styles.ofPrimaryBtnColor,
                    },
                }}
                centered
                onCancel={handleCancel}
                width={800}
                modalRender={(dom) => (
                    <Form
                        form={useForm}
                        layout="vertical"
                        onFinish={handleCollateralSave}
                        name="address-info"
                    >
                        {dom}
                    </Form>
                )}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Row>
                        <Divider />
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item
                                name={"collateralId"}
                                label={"Collateral Options"}
                                rules={[
                                    {
                                        required: true,
                                        message: BOM.CheckReqFld(labelConfig.collateral),
                                    },
                                ]}
                            >
                                <Select
                                    filterOption={(input, option) =>
                                        (option?.label?.toLowerCase() ?? "").includes(
                                            input?.toLowerCase()
                                        )
                                    }
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.collateral,
                                        "select"
                                    )}
                                    options={collateralData}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.value} name="collateralValue">
                                <Input
                                    placeholder={BOM.handlePlaceholderMsg(labelConfig.value)}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ padding: "0px 8px" }}>
                            <Form.Item label={labelConfig.description} name="description">
                                <TextArea
                                    placeholder={BOM.handlePlaceholderMsg(
                                        labelConfig.description
                                    )}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Spin>
            </Modal>
        </Row>
    );
};

const RepaymentInfoModal = (props) => {
    const { repaymentInfoColumns, setIsLoading, session } = props;
    const [useForm] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [repaymentInfoList, setRepaymentInfoList] = useState([]);

    const getDetail = () => {
        const params = {
            command: "calculateLoanSchedule",
        };

        const url = `${apiConfig.Loans}`;

        let body = {
            session,
            params,
        };

        setIsLoading(true);

        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;

                let tempRepaymentInfoArray = [];

                objDetail?.periods?.forEach((element) => {
                    tempRepaymentInfoArray.push({
                        key: element?.id,
                        id: element?.id,
                        date: element?.dueDate
                            ? BOM.DateTime(element?.dueDate, "only-date")
                            : "-",
                        days: element?.daysInPeriod ? element?.daysInPeriod : "-",
                        disbursement: element?.principalDisbursed
                            ? element?.principalDisbursed
                            : "-",
                        principalDue: element?.principalDue ? element?.principalDue : "-",
                        pricipalBalance: element?.principalLoanBalanceOutstanding
                            ? element?.principalLoanBalanceOutstanding
                            : "-",
                        interestDue: element?.interestDue ? element?.interestDue : "-",
                        fees: element?.feeChargesDue ? element?.feeChargesDue : "-",
                        penalty: element?.penaltyChargesDue
                            ? element?.penaltyChargesDue
                            : "-",
                        dues: element?.totalDueForPeriod ? element?.totalDueForPeriod : "-",
                    });
                });

                setRepaymentInfoList(tempRepaymentInfoArray);
                setIsLoading(false);
            }
        });
    };

    const handleClick = () => {
        setIsModalOpen(true);
        getDetail();
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Row>
            <Button
                type="primary"
                shape="round"
                disabled={true}
                onClick={handleClick}
                style={{
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    backgroundColor: "#92428B",
                    marginBottom: 20,
                }}
            >
                {labelConfig.repaymentInfo}
            </Button>

            <Modal
                title="Repayment Information"
                open={isModalOpen}
                footer={null}
                onCancel={handleCancel}
                width={1000}
            >
                <Form form={useForm} layout="vertical" name="address-info">
                    <Divider />

                    <Table
                        columns={repaymentInfoColumns}
                        dataSource={repaymentInfoList}
                    />

                    <Row>
                        <CustomButton
                            content="Cancel"
                            style={{
                                width: "10%",
                                marginLeft: "auto",
                                marginTop: 20,
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            }}
                            backgroundColor="#fff"
                            colorText="black"
                            hoverBackground="#F5F5F5"
                            onClick={() => setIsModalOpen(false)}
                        />
                    </Row>
                </Form>
            </Modal>
        </Row>
    );
};